module.exports = __webpack_public_path__ + "static/media/nz-quiz-icon.a95d1729.svg";